/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Picker_Last_MonthInputs */

const fr_date_picker_last_month = /** @type {(inputs: Date_Picker_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il y a un mois`)
};

const en_date_picker_last_month = /** @type {(inputs: Date_Picker_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A month ago`)
};

/**
* | output |
* | --- |
* | "A month ago" |
*
* @param {Date_Picker_Last_MonthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const date_picker_last_month = /** @type {((inputs?: Date_Picker_Last_MonthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Picker_Last_MonthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_date_picker_last_month(inputs)
	return fr_date_picker_last_month(inputs)
});